import clsx from 'clsx'
import { BasicStyledComponent } from 'shared-definitions/types'
import styles from './PageExcerpt.module.css'

type PageExcerptProps = BasicStyledComponent

const PageExcerpt: React.FC<PageExcerptProps & React.PropsWithChildren> = ({
  children,
  className,
}) => <div className={clsx(styles.pageExcerpt, className)}>{children}</div>

export default PageExcerpt
